import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../state";

export const createShift = createAsyncThunk('createShift', async (data: any) => {
    try {
        const response = await axios({
            method: 'post',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/shift',
            data: data
        })
        return response
    } catch (error: any) {
        return error.response
    }
})

export const deleteShift = createAsyncThunk('deleteShift', async (id: string) => {
    try {
        const response = await axios({
            method: 'delete',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/shift?id=' + id,
        })
        return response
    } catch (error: any) {
        return error.response
    }
})

export const editShift = createAsyncThunk('editShift', async (data: any) => {
    try {
        const response = await axios({
            method: 'put',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/shift',
            data: data
        })
        return response
    } catch (error: any) {
        return error.response
    }
})